.marketPartyUsers__user {
  align-items: center;
  border-bottom: 1px solid gray;
  display: flex;
  justify-content: space-between;
}
